import React from "react";
import { Button, Title, useAuth } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { CreateRequestPageState } from "../models";

interface Props {
  title: string;
  description: string;
  requestPageParams?: CreateRequestPageState;
}

const RequestCreateAlert: React.FC<Props> = (props): React.ReactElement => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { tRequest } = useCustomTranslation();

  if (!user?.isEditor) return <div />;

  return (
    <div className="border-gray mt-8 flex flex-col justify-between rounded-2xl border p-6 sm:flex-row sm:items-center">
      <div className="flex-1">
        <Title title={props.title} />
        <p>{props.description}</p>
      </div>
      <Button
        label={tRequest("create_button")}
        mode="primary"
        onClick={() =>
          navigate.goTo("requests/create", {
            state: props.requestPageParams,
          })
        }
        className="mt-2 sm:mt-0 sm:ml-4"
      />
    </div>
  );
};

export default RequestCreateAlert;
